export default "__VITE_ASSET__BJqZ4IxV__"